/**
 * This variable key is used to store/retrieve the user-service generated access-tokens.
 *
 * Scenarios which SET the value: `sign-in-with-axauth`, `sign-in-with-external-idps`, `renew-access-token`
 */
export const VAR_KEY_AX_USER_ACCESS_TOKEN = 'AX_USER_ACCESS_TOKEN';
